import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 50,
	viewBox: "0 0 60 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1248_21374)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M60 5.63965H5V17.6396H60V5.63965Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56 48.6396H1V1.63965H56V48.6396Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 11.6396H56",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.5 7.63965C50.3284 7.63965 51 6.96808 51 6.13965C51 5.31122 50.3284 4.63965 49.5 4.63965C48.6716 4.63965 48 5.31122 48 6.13965C48 6.96808 48.6716 7.63965 49.5 7.63965Z",
				fill: "#256F94"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.5 7.63965C44.3284 7.63965 45 6.96808 45 6.13965C45 5.31122 44.3284 4.63965 43.5 4.63965C42.6716 4.63965 42 5.31122 42 6.13965C42 6.96808 42.6716 7.63965 43.5 7.63965Z",
				fill: "#256F94"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.5 7.63965C38.3284 7.63965 39 6.96808 39 6.13965C39 5.31122 38.3284 4.63965 37.5 4.63965C36.6716 4.63965 36 5.31122 36 6.13965C36 6.96808 36.6716 7.63965 37.5 7.63965Z",
				fill: "#256F94"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.45 23.4297V33.4297",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.9199 32.1499L28.4499 35.6899L31.9899 32.1499",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.95 38.4297H36.95",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1248_21374",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 49,
			fill: "white",
			transform: "translate(0 0.639648)"
		})
	}) })]
});
export default SvgDownloadData;
